export default __webpack_public_path__ + "static/EPA-Application-Guide-85b82f9e4e79d93c5b353d842c69dfa7.pdf";